<div class="kpi-wrapper d-flex flex-row flex-nowrap align-items-center">
  <div class="kpi-entity d-flex flex-wrap flex-column align-items-center" *ngFor="let kpi of kpiSummaryData">
    <div class="kpi-title text-center">{{labels[kpi.type]}}</div>
    <div class="kpi-value">
      {{kpi.value | largeNumeralShortener:kpi.currency}}
    </div>
    <div class="yoy-growth" *ngIf="kpi.yoy !== null" [ngClass]="kpi.yoy >= 0 ? 'positive' : 'negative'">
      {{kpi.yoy > 0 ? '+' : ''}}{{kpi.yoy}}%
      <label i18n="@@amadeus-direct.avc-dashboard.yoy-growth">YOY</label>
    </div>
  </div>
</div>
